import { to } from 'nh-utils'
import api from 'lib/api'

export const getSample = () => to(api.get('/sample'))
export const genericPost = payload => to(api.post('/sample', payload))
